<div class="ui-g-12">

    <p-organizationChart [style]="{'width': '80%', 'overflow-x': 'auto', 'float': 'left'}" [value]="base_tree" *ngIf="data != null">
        <ng-template let-node pTemplate="node">
            <div class="node-header ui-corner-top" style="padding: 5px; font-size: 10px; width:128px">{{node.label | translate}}</div>
            <div *ngIf="node.data.type != 'legend'"  class="node-content">
                <div style="font-size: 18px; width: 50%; display: inline;">
                    <span *ngIf="node.data.type=='currency'">€</span>
                    {{node.data.current | numberPrefix:'0.0-2':'it' }}
                </div>
                <div style="font-size: 14px; width: 50%; display: inline; color: gray;">
                    <span *ngIf="node.data.type=='currency'">€</span>
                    {{node.data.previous | numberPrefix:'0.0-2':'it' }}
                </div>
                <div [ngStyle]="{'color': node.data.percent >= 0 ? 'green' : 'red', 'width':'100%', 'padding':'5px', 'font-weight':'bold'}">
                    {{node.data.percent | number:'.0-2'}}%
                </div>
            </div>
        </ng-template>
    </p-organizationChart>

    <p-organizationChart [style]="{'width': '20%', 'overflow-x': 'auto', 'float': 'right' }" [value]="base_tree_legend" *ngIf="data != null">
        <ng-template let-node pTemplate="node">
            <div class="node-header ui-corner-top" style="padding: 5px; font-size: 10px;">{{node.label | translate}}</div>
            <div *ngIf="node.data.type == 'legend'"  class="node-content">
                <div style="font-size: 18px; width: 50%; display: inline;">
                    {{node.data.current}}
                </div>
                <div style="font-size: 14px; width: 50%; display: inline; color: gray;">
                    {{node.data.previous}}
                </div>
                <div [ngStyle]="{'width':'100%', 'padding':'5px', 'font-weight':'bold'}">
                    {{node.data.percent}}
                    <span style="color: green;">+</span>
                    /
                    <span style="color: red;">-</span>
                </div>
            </div>
        </ng-template>
    </p-organizationChart>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/revenue-analysis/tree/revenue-analysis-tree.component.html